import React from 'react';
import { canvasSize } from '../index';

export const path =
  'M7,2.5 C4.51471863,2.5 2.5,4.51471863 2.5,7 C2.5,9.48528137 4.51471863,11.5 7,11.5 C9.48528137,11.5 11.5,9.48528137 11.5,7 L13,7 C13,10.3137085 10.3137085,13 7,13 C3.6862915,13 1,10.3137085 1,7 C1,3.6862915 3.6862915,1 7,1 L7,0 L11,1.75 L7,3.5 L7,2.5 Z';

export default class Ajax extends React.PureComponent {
  render() {
    return (
      <g className="d-ib anim-spin anim-duration-10 anim-iter-infinite anim-fill-both anim-timing-linear">
        <rect width={canvasSize} height={canvasSize} opacity="0" />
        <path d={path} className="fill-current" />;
      </g>
    );
  }
}
